import React from 'react';

/** Логотип Яндекса: красный круг с белой «Я» */
export const YandexIcon: React.FC<{size?: number}> = ({size = 20}) => (
	<svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
		<circle cx="12" cy="12" r="10" fill="#FC3F1D" />
		<path
			d="M12.792 17.7h1.73V6.312h-2.4c-2.51 0-3.86 1.31-3.86 3.11 0 1.62.63 2.53 1.93 3.36l-2.28 4.91h1.86l2.49-5.26-.86-.52c-1.09-.7-1.61-1.32-1.61-2.61 0-1.1.79-1.86 2.02-1.86h.98V17.7z"
			fill="#fff"
		/>
	</svg>
);
